import mailCategoryReducer from './MailCategoryReducer';

const initialState = {
  A: {}, B: {}, C: {}, D: {},
};

function categoryWrapper(state, action, allMailSubClassCodes, category) {
  return (!action.category || action.category === category)
    ? mailCategoryReducer(state, action, allMailSubClassCodes)
    : state;
}

export default (state = initialState, action, allMailSubClassCodes) => {
  const A = categoryWrapper(state.A, action, allMailSubClassCodes, 'A');
  const B = categoryWrapper(state.B, action, allMailSubClassCodes, 'B');
  const C = categoryWrapper(state.C, action, allMailSubClassCodes, 'C');
  const D = categoryWrapper(state.D, action, allMailSubClassCodes, 'D');
  return {
    A, B, C, D,
  };
};

